var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 150 150",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M123.267,121.635C123.076,116.059 122.425,110.458 121.455,104.969C120.28,98.32 118.785,88.571 112.998,84.238C109.652,81.733 105.318,80.911 101.487,79.4C99.622,78.665 97.952,77.935 96.384,77.104C91.093,82.925 84.194,85.97 76.159,85.971C68.127,85.971 61.228,82.926 55.937,77.104C54.37,77.935 52.699,78.665 50.835,79.4C47.004,80.911 42.67,81.732 39.324,84.238C33.537,88.571 32.042,98.32 30.867,104.969C29.897,110.458 29.246,116.059 29.055,121.635C28.908,125.954 31.034,126.559 34.635,127.863C39.144,129.495 43.8,130.706 48.487,131.699C57.539,133.617 66.87,135.091 76.16,135.157C85.451,135.091 94.782,133.617 103.834,131.699C108.521,130.707 113.177,129.495 117.686,127.863C121.289,126.56 123.414,125.954 123.267,121.635ZM76.161,79.982C93.575,79.981 99.84,62.489 101.481,48.12C103.501,30.418 95.158,17.095 76.161,17.095C57.167,17.095 48.82,30.417 50.842,48.119C52.484,62.488 58.747,79.983 76.161,79.982Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.6cccb5d2de2e3f34388c1b84076b389b.svg";
export { ForwardRef as ReactComponent };